<template>
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:p-6 lg:p-8">
      <div class="bg-white p-4 sm:p-6 lg:p-4 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
        <h2 class="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800">
          Review Your Order
        </h2>
        
        <table class="w-full text-left border-collapse">
          <thead>
            <tr>
              <th class="p-2 border-b-2">Item Name</th>
              <th class="p-2 border-b-2">Quantity</th>
              <th class="p-2 border-b-2">Price (FRw)</th>
              <th class="p-2 border-b-2">Total (FRw)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order, index) in orders.items" :key="index" class="hover:bg-gray-100">
              <td class="p-2 border-b">{{ order.name }}</td>
              <td class="p-2 border-b">{{ order.quantity }}</td>
              <td class="p-2 border-b">{{ order.price }}</td>
              <td class="p-2 border-b">{{ +order.price * +order.quantity }}</td>
            </tr>
  
            <tr v-if="orders.length === 0">
              <td colspan="4" class="text-center text-gray-500 p-4">No items in your order.</td>
            </tr>
          </tbody>
        </table>
  
        <p class="text-lg font-bold mt-4 text-gray-800">Total Order Value: {{ orders.totalAmount }} FRw</p>
        
        <div class="flex space-x-4 mt-4">
          <button @click="submitOrder" 
                  class="bg-green text-white p-2 rounded-lg hover:bg-green w-full sm:w-auto">
            Submit Order
          </button>
          <button @click="cancelOrder" 
                  class="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 w-full sm:w-auto">
            Cancel Order
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  
  export default {
    computed: {
      ...mapState('orders', {
        orders: state => state.orders,
      }),
      totalOrderValue() {
        return this.orders.items.reduce((total, currentItem) => {
          const price = +currentItem.price * +currentItem.quantity || 0;
          return total + price;
        }, 0);
      }
    },
    methods: {
      ...mapActions('orders', {
           clearOrders:'clearOrders',
           placeOrder: 'placeOrder'
      }),
      submitOrder() {
        this.placeOrder(this.orders)
        alert('Order submitted successfully!');
        this.clearOrders();
      },
      cancelOrder() {
        if (confirm('Are you sure you want to cancel your order?')) {
          this.clearOrders();
        }
      }
    }
  };
  </script>
  